import { Injectable } from '@angular/core';
import {Translation} from "./translation";
import {GermanTranslation} from "./german-translation";
import {EnglishTranslation} from "./english-translation";

@Injectable({
  providedIn: 'root'
})
export class LocaleService {
  public currentLocale: string = 'DE';
  private readonly _germanLocale = 'DE';
  private readonly _englishLocale = 'EN';
  public currentTranslation: Translation = new GermanTranslation();


  constructor() {
  }

  private setGermanTranslation() {
    this.currentTranslation = new GermanTranslation();
    this.currentLocale = this._germanLocale
  }
  private setEnglishTranslation() {
    this.currentTranslation = new EnglishTranslation();
    this.currentLocale = this._englishLocale
  }

  toggleTranslation() {
    if (this.currentLocale === this._germanLocale) {
      this.setEnglishTranslation();
    } else {
      this.setGermanTranslation()
    }
  }
}
